var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 600 600",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#00a0df;}.cls-2{fill:#fff;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "info") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_93",
    "data-name": "Layer 93"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 300.71,
    cy: 300,
    r: 299.69
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 247.85,
    y: 244.33,
    width: 104.3,
    height: 263.11,
    rx: 52.15
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 300,
    cy: 154.37,
    r: 52.15
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.fcfbfe1eb5ddc324518316995a713e47.svg";
export { ForwardRef as ReactComponent };